(function () {
  'use strict';

  function normalize(value) {
    return (value || '')
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function init(root) {
    if (root.dataset.ghxReady === '1') return;
    root.dataset.ghxReady = '1';

    var input = root.querySelector('[data-ghx-input]');
    var clear = root.querySelector('[data-ghx-clear]');
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-ghx-row]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-ghx-series]'));
    var count = root.querySelector('[data-ghx-count]');
    var empty = root.querySelector('[data-ghx-empty]');

    rows.forEach(function (row) {
      row.dataset.ghxHaystack = normalize(row.dataset.ghxSearch || row.textContent);
    });

    function apply() {
      var term = normalize(input ? input.value : '');
      var terms = term ? term.split(' ') : [];
      var shown = 0;

      rows.forEach(function (row) {
        var hay = row.dataset.ghxHaystack;
        var visible = terms.every(function (t) { return hay.indexOf(t) !== -1; });
        row.hidden = !visible;
        if (visible) shown++;
      });

      groups.forEach(function (group) {
        var any = group.querySelector('[data-ghx-row]:not([hidden])');
        group.hidden = !any;
      });

      root.classList.toggle('is-searching', !!term);

      if (count) {
        count.hidden = !term;
        count.textContent = shown === 1
          ? '1 model matches.'
          : shown + ' models match.';
      }
      if (empty) empty.hidden = shown !== 0;
    }

    if (input) {
      input.addEventListener('input', apply);
      input.addEventListener('search', apply);
    }
    if (clear) {
      clear.addEventListener('click', function () {
        if (input) { input.value = ''; input.focus(); }
        apply();
      });
    }
    apply();
  }

function initPicker(root) {
    if (root.dataset.ghxReady === '1') return;
    root.dataset.ghxReady = '1';

    var serieSel = root.querySelector('[data-ghx-series]');
    var modelSel = root.querySelector('[data-ghx-model]');
    var go = root.querySelector('[data-ghx-go]');
    var hint = root.querySelector('[data-ghx-hint]');
    if (!serieSel || !modelSel || !go) return;

    var placeholder = modelSel.options[0];
    var all = Array.prototype.slice.call(modelSel.options).filter(function (o) {
      return o.value;
    });

    function fill() {
      var serie = serieSel.value;
      modelSel.innerHTML = '';
      modelSel.appendChild(placeholder);
      if (serie) {
        all.forEach(function (o) {
          if (o.dataset.series === serie) modelSel.appendChild(o);
        });
      }
      modelSel.value = '';
      modelSel.disabled = !serie;
      say();
    }

    function say() {
      if (!hint) return;
      var o = modelSel.selectedOptions && modelSel.selectedOptions[0];
      if (!o || !o.value) { hint.hidden = true; hint.textContent = ''; return; }
      var w = o.dataset.width;
      var fit = o.dataset.fit || '';
      hint.hidden = false;
      hint.innerHTML = w && w !== '0'
        ? 'The <strong>' + o.dataset.model + '</strong> takes a <strong>' + w + ' mm</strong> strap' +
          (fit ? ' &mdash; ' + fit : '') + '.'
        : 'The <strong>' + o.dataset.model + '</strong> uses a Garmin-only band, with no standard size.';
    }

    function jump() {
      if (!serieSel.value) { serieSel.focus(); return; }
      var url = modelSel.value;
      if (!url) { modelSel.focus(); return; }
      window.location.href = url;
    }

    serieSel.addEventListener('change', fill);
    modelSel.addEventListener('change', say);
    go.addEventListener('click', jump);
    modelSel.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); jump(); }
    });

    modelSel.disabled = true;
  }

function initDock(dock) {
    if (dock.dataset.ghxReady === '1') return;
    dock.dataset.ghxReady = '1';

    var tab = dock.querySelector('[data-ghx-dock-toggle]');
    if (!tab) return;

    function set(open) {
      dock.dataset.open = open ? 'true' : 'false';
      tab.setAttribute('aria-expanded', open ? 'true' : 'false');
      try {
        sessionStorage.setItem('ghxDock', open ? '1' : '0');
      } catch (err) {
}
    }

    var saved = null;
    try { saved = sessionStorage.getItem('ghxDock'); } catch (err) {
}
    set(saved === '1');

    tab.addEventListener('click', function () {
      set(dock.dataset.open !== 'true');
    });
  }

var FOCUSABLE = 'a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])';
  var openModal = null;
  var lastFocus = null;

  function close() {
    if (!openModal) return;
    var m = openModal;
    openModal = null;
    m.dataset.open = 'false';
    document.documentElement.classList.remove('ghx-locked');
    document.body.classList.remove('ghx-locked');

    window.setTimeout(function () {
      if (m.dataset.open === 'false') m.hidden = true;
    }, 240);

    if (lastFocus && lastFocus.focus) lastFocus.focus();
    lastFocus = null;
  }

function readTone(modal) {
    var img = modal.querySelector('.ghx-modal__figure img');
    var btn = modal.querySelector('[data-ghx-modal-close]');
    if (!img || !btn || btn.dataset.tone) return;

    var probe = new Image();
    probe.crossOrigin = 'anonymous';

    probe.onload = function () {
      try {
        var box = 24;
        var canvas = document.createElement('canvas');
        canvas.width = box;
        canvas.height = box;
        var ctx = canvas.getContext('2d');

        var sw = Math.max(1, Math.round(probe.naturalWidth * 0.18));
        var sh = Math.max(1, Math.round(probe.naturalHeight * 0.18));
        ctx.drawImage(probe, probe.naturalWidth - sw, 0, sw, sh, 0, 0, box, box);

        var px = ctx.getImageData(0, 0, box, box).data;
        var sum = 0;
        var seen = 0;
        for (var i = 0; i < px.length; i += 4) {
          if (px[i + 3] < 20) continue;
          sum += 0.2126 * px[i] + 0.7152 * px[i + 1] + 0.0722 * px[i + 2];
          seen++;
        }
        btn.dataset.tone = (seen && (sum / seen) > 140) ? 'light' : 'dark';
      } catch (err) {
        btn.dataset.tone = 'dark';
      }
    };

    probe.onerror = function () { btn.dataset.tone = 'dark'; };
    probe.src = img.currentSrc || img.src;
  }

  function open(modal, trigger) {
    if (!modal) return;
    lastFocus = trigger || document.activeElement;
    modal.hidden = false;
    document.documentElement.classList.add('ghx-locked');
    document.body.classList.add('ghx-locked');
    openModal = modal;

    readTone(modal);

    window.requestAnimationFrame(function () {
      modal.dataset.open = 'true';
      var first = modal.querySelector('[data-ghx-modal-close]');
      if (first) first.focus();
    });
  }

  function initModals() {
    document.querySelectorAll('[data-ghx-modal-open]').forEach(function (btn) {
      if (btn.dataset.ghxReady === '1') return;
      btn.dataset.ghxReady = '1';
      btn.addEventListener('click', function (e) {
        var modal = document.getElementById(btn.dataset.ghxModalOpen);
        if (!modal) return;
        e.preventDefault();
        open(modal, btn);
      });
    });

    document.querySelectorAll('[data-ghx-modal]').forEach(function (modal) {
      if (modal.dataset.ghxReady === '1') return;
      modal.dataset.ghxReady = '1';

      var isPhoto = modal.classList.contains('ghx-modal--photo');

      modal.addEventListener('click', function (e) {
        if (e.target === modal) { close(); return; }

        if (isPhoto &&
            e.target.tagName !== 'IMG' &&
            !e.target.closest('[data-ghx-modal-close]')) {
          close();
        }
      });
      var x = modal.querySelector('[data-ghx-modal-close]');
      if (x) x.addEventListener('click', close);
    });
  }

  document.addEventListener('keydown', function (e) {
    if (!openModal) return;

    if (e.key === 'Escape') { close(); return; }

    if (e.key === 'Tab') {
      var items = Array.prototype.slice
        .call(openModal.querySelectorAll(FOCUSABLE))
        .filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;

      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    }
  });

  function boot() {
    document.querySelectorAll('[data-ghx-finder]').forEach(init);
    document.querySelectorAll('[data-ghx-picker]').forEach(initPicker);
    document.querySelectorAll('[data-ghx-dock]').forEach(initDock);
    initModals();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
